<template>
    <v-container
        fluid
        class="px-4"
        v-if="booking">
        <v-row>
            <v-col cols="6">
                <div class="subtitle-1 font-weight-bold">
                    {{ $t('bookingList.bookingDetails.bookingNo') }}
                </div>
                <div class="subtitle-2">
                    {{ booking.id }}
                </div>
            </v-col>
            <v-col cols="6">
                <div class="subtitle-1 font-weight-bold">
                    {{ $t('bookingList.bookingDetails.bookingDate') }}
                </div>
                <div class="subtitle-2">
                    {{ $util.getDDMMYYYYHHSSDateFormat(booking.createdAt) }}
                </div>
            </v-col>
            <v-col cols="6">
                <div class="subtitle-1 font-weight-bold">
                    {{ $t('bookingList.bookingDetails.firstName') }}
                </div>
                <div class="subtitle-2">
                    {{ firstName }}
                </div>
            </v-col>
            <v-col cols="6">
                <div class="subtitle-1 font-weight-bold">
                    {{ $t('bookingList.bookingDetails.lastName') }}
                </div>
                <div class="subtitle-2">
                    {{ lastName }}
                </div>
            </v-col>
            <v-col cols="6">
                <div class="subtitle-1 font-weight-bold">
                    {{ $t('bookingList.bookingDetails.travelDate') }}
                </div>
                <div class="subtitle-2">
                    {{ $util.getDDMMYYYYDateFormat(booking.visitDate) }}
                </div>
            </v-col>

            <hr class="full-width ma-4">

            <v-col cols="12">
                <product-table
                    :excludeHeaders="productTableExcludeHeaders"
                    :items="booking.products"/>
            </v-col>
        </v-row>
    </v-container>
    <div v-else/>
</template>

<script>
import ProductTable from '@/components/tables/ProductTable'

export default {
    name: 'BookingDetailsView',

    components: {
        ProductTable
    },

    props: {
        booking: {
            type: Object,
            default: () => ({})
        },

        productTableExcludeHeaders: {
            type: Array,
            default: () => []
        }
    },

    computed: {
        firstName () {
            return this.booking.user?.name
        },

        lastName () {
            return this.booking.user?.lastname
        }
    }
}
</script>

<style lang="scss" scoped></style>
